import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { injectIntl, FormattedMessage } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';
import enums from '../../constants/defaultEnums';
import formUtils from '../../utils/formUtils';
import {
  CustomSelectField,
  CustomInputField,
  CustomDateField,
  CustomLocationAddressField
} from '../../components';

function PersonalForm({ intl, form, languagesOptions }) {
  const language = 'en';
  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  const MIN_DATE = moment("01/01/1900", "MM/DD/YYYY").utc();

  const filterLanguages = (search, selectedValues) => {
    const regex = new RegExp(`${search.trim()}`, 'i');

    const filteredOptions = languagesOptions
      .filter((l) => regex.test(l.display_name) || selectedValues?.includes(l.value))
      .map((l) => ({
        label: l.display_name,
        value: l.value,
      }));

    return Promise.resolve({ options: filteredOptions });
  };

  return (
    true ? (
      <div>
        <h3 className='mb-2 personal ui-h3-heavy'>
          <FormattedMessage
            id="HZaC7L"
            description="personalInformation"
            defaultMessage="Personal Information"
          />
        </h3>
        <CustomInputField
          name="first_name"
          label={<FormattedMessage
            id="baGCLv"
            description="firstName"
            defaultMessage="First Name"
          />}
          id="uu_contact_first_name"
          required
          language={language}
        />
        <CustomInputField
          name="last_name"
          label={<FormattedMessage
            id="2cVC+q"
            description="lastName"
            defaultMessage="Last Name"
          />}
          id="uu_contact_last_name"
          required
          language={language}
        />
        <CustomInputField
          name="medicaid_id"
          label={<FormattedMessage
            id="yVIyqS"
            description="medicaidId"
            defaultMessage="Medicaid ID"
          />}
          id="uu_contact_medicaid_id"
          required
          language={language}
        />
        <CustomDateField
          name="date_of_birth"
          label={<FormattedMessage
            id="Hid0zr"
            description="dateOfBirth"
            defaultMessage="Date of Birth"
          />}
          id="uu_contact_date_of_birth"
          other={{
            maxDate: yesterdayDate,
            minDate: MIN_DATE,
          }}
          required
          language={language}
        />
        <CustomSelectField
          name="preferred_written_languages"
          label={<FormattedMessage
            id="q8T0PX"
            description="preferredWrittenLanguages"
            defaultMessage="Preferred Written Languages"
          />}
          id="uu_contact_preferred_written_languages"
          options={formUtils.translateOptions(intl, languagesOptions)}
          loadOptions={(search) => filterLanguages(search, form.getFieldState('preferred_written_languages').value)}
          multiple
          language={language}
        />
        <CustomSelectField
          name="preferred_spoken_languages"
          label={<FormattedMessage
            id="RCuAgT"
            description="preferredSpokenLanguages"
            defaultMessage="Preferred Spoken Languages"
          />}
          id="uu_contact_preferred_spoken_languages"
          options={formUtils.translateOptions(intl, languagesOptions)}
          loadOptions={(search) => filterLanguages(search, form.getFieldState('preferred_spoken_languages').value)}
          multiple
          language={language}
        />
        <CustomInputField
          name="phone_number"
          label={<FormattedMessage
            id="9cZViq"
            description="phoneNumber"
            defaultMessage="Phone number"
          />}
          id="uu_contact_phone_number"
          mask="(999)-999-9999"
          required
          language={language}
        />
        <CustomInputField
          name="email_address"
          label={<FormattedMessage
            id="u2ISfJ"
            description="emailAddress"
            defaultMessage="Email Address"
          />}
          id="uu_contact_email_address"
          required
          language={language}
        />
        <div>
          <CustomSelectField
            name="address_type"
            id="uu_contact_address_type"
            label={<FormattedMessage
              id="4ueNhi"
              description="addressType"
              defaultMessage="Address Type"
            />}
            options={formUtils.translateOptions(intl, enums.contact_data.address_types)}
            required
            language={language}
          />
          <CustomLocationAddressField
            name="address_line_1"
            id="uu-address-typeahead"
            label={intl.formatMessage({
              id: "2U37j6",
              description: 'address',
              defaultMessage: 'Address',
            })}
            language={language}
            required
          />
          <CustomInputField
            name="line_2"
            id="uu_contact_line_2"
            label={<FormattedMessage
              id="+/mcIK"
              description="addressLine2"
              defaultMessage="Address Line 2"
            />}
          />
        </div>
      </div>
    ) : ''
  );
}

export default injectIntl(PersonalForm);
